import { render, staticRenderFns } from "./shift.vue?vue&type=template&id=fa9daeb6&scoped=true&"
import script from "./shift.vue?vue&type=script&lang=js&"
export * from "./shift.vue?vue&type=script&lang=js&"
import style0 from "./shift.vue?vue&type=style&index=0&id=fa9daeb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9daeb6",
  null
  
)

export default component.exports